import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import imageUrls from '../images/imageUrls';
import { getWindowLocationHref } from '../routing/getWindowLocationHref';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { clearError } from '../store/error/action-creators';
import { isFlow } from '../utils/isFlow';
import { isIntegration } from '../utils/isIntegration';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const ExistingAccountLoginView = () => {
  const {
    redirectToLogin
  } = useLoginRedirect();
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    const url = getWindowLocationHref();
    const isIntegrationFlow = isFlow(Flow.Integrations);
    const isWordpressIntegration = isIntegration(Integration.Wordpress);
    redirectToLogin(isIntegrationFlow && isWordpressIntegration ? {
      redirectUrl: url
    } : {});
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.OAuthExistingLoginFailed,
    handleButtonClick: handleButtonClick,
    handleLinkClick: () => {
      dispatch(clearError());
    },
    imageURL: imageUrls.door
  });
};

export default ExistingAccountLoginView;